import { Dialog, DialogContent } from "@mui/material";
import { Button } from "@truevault/aquilo";
import { CloseableDialogTitle } from "../../../../../components/dialog/CloseableDialogTitle";
import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../../../../root/routes";

type AfterRoPASaveDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const AfterRoPASaveDialog = ({ isOpen, onClose }: AfterRoPASaveDialogProps) => {
  const history = useHistory();

  return (
    <Dialog
      className="help-dialog"
      open={isOpen}
      fullWidth={true}
      maxWidth={"md"}
      onClose={onClose}
      aria-label="RoPA Saved"
    >
      <CloseableDialogTitle onClose={onClose}>
        This version of your RoPA has been saved to your version history.
      </CloseableDialogTitle>
      <DialogContent className="help-dialog-content">
        <p className="mt-0">Go to Version History to view and download previous versions.</p>
        <div className="flex-row justify-end gap-sm tw-boundary" style={{ textAlign: "right" }}>
          <Button color="tertiary" onClick={onClose}>
            Stay
          </Button>
          <Button
            color="primary"
            onClick={() => {
              history.push(Routes.documents.recordOfProcessingActivities.history);
            }}
          >
            Go to Version History
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
